import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

import { Row } from 'react-bootstrap'

/**
 * @param {{
 *    className?: string
 * }} props
 * @returns {React.Component}
 */
const ZariRow = ({ className, ...props }) => {
  return <Row {...props} className={clsx('zr-row', className)} />
}

ZariRow.propTypes = {
  className: PropTypes.string
}

export default ZariRow
